import React from 'react';
import { Layout } from '@/components/layout/Layout';
import Seo from '@/components/Seo';
import UseCasesNav from '@/components/use-cases/UseCasesNav';
import { Button } from '@/components/ui/button';

const cards = [
  {
    title: 'Small Business',
    description: 'Grow local visibility, protect reputation, and convert reviews into trust.',
    href: '/use-cases/small-business'
  },
  {
    title: 'Multi-Location Chains',
    description: 'Standardize brand trust signals across locations and markets.',
    href: '/use-cases/chains'
  },
  {
    title: 'Agencies',
    description: 'Deliver review management and local SEO outcomes for your clients.',
    href: '/use-cases/agencies'
  },
  {
    title: 'Healthcare',
    description: 'Build patient trust, manage sensitive feedback, and stay compliant.',
    href: '/use-cases/healthcare'
  },
  {
    title: 'Education',
    description: 'Maintain trust signals across schools, colleges, and training providers.',
    href: '/use-cases/education'
  }
];

export default function UseCasesPage() {
  return (
    <Layout>
      <Seo
        title="Use Cases"
        description="Explore use cases for small businesses, chains, agencies, healthcare, and education."
        path="/use-cases"
      />
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 space-y-8">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-slate-500 font-body">Use Cases</p>
            <h1 className="text-4xl lg:text-5xl font-black font-heading text-slate-900 mt-4">
              Corporate Use Case Library
            </h1>
            <p className="text-lg text-slate-600 mt-4 max-w-3xl font-body">
              Structured, executive‑ready programmes tailored to business models and regulated environments.
            </p>
          </div>
          <UseCasesNav />
        </div>
      </section>

      <section className="pb-24 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 space-y-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 p-6 rounded-2xl border border-slate-200 bg-white"
            >
              <div>
                <h2 className="text-xl font-bold font-heading text-slate-900">{card.title}</h2>
                <p className="text-slate-600 font-body mt-2">{card.description}</p>
              </div>
              <Button asChild className="bg-slate-900 text-white hover:bg-slate-800">
                <a href={card.href}>View Use Case</a>
              </Button>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
